import { CopyButton } from "../CopyButton/CopyButton";

interface CopyableValueProps {
    value: string | null | undefined;
    fallback?: string;
    label?: string;
}

/** Отображает значение, которое можно скопировать. */
export const CopyableValue = (
    { value, fallback = '—', label = 'Копировать' }: CopyableValueProps
) => {
    if (!value) {
        return <span>{fallback}</span>;
    }

    return (
        <div className="flex align-items-center gap-2">
            <span>{value}</span>
            <CopyButton
                value={value}
                label={label}
            />
        </div>
    );
};
